import { useState } from "react";
import { fmtTime } from "@/lib/api";
import { usePoll, PageHeader, Panel, Pill } from "@/components/common";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

export default function AccessLog() {
  const [tab, setTab] = useState("all");
  const q = tab === "all" ? "" : `&allowed=${tab === "allowed"}`;
  const { data } = usePoll(`/admin/access-log?limit=300${q}`, 4000);
  const { data: pullers } = usePoll("/admin/pullers", 3000);
  return (
    <div>
      <PageHeader title="Access log" sub="Every allowed and refused stream request, and who is pulling right now." />
      <Panel title={`Pulling now · ${pullers?.length || 0}`} className="mb-4" testid="pullers-panel">
        {(pullers || []).length === 0 ? <p className="text-sm text-slate-500">No active pullers.</p> : (
          <table className="w-full text-xs font-mono">
            <thead><tr className="text-left text-[10px] uppercase tracking-wider text-slate-500">{["IP", "Server", "Channel", "Format", "Since", "Idle"].map((h) => <th key={h} className="pb-1 font-semibold">{h}</th>)}</tr></thead>
            <tbody>{pullers.map((p, i) => (
              <tr key={i} className="border-t border-slate-800/60"><td className="py-1.5 text-slate-200">{p.ip}</td><td className="text-slate-300">{p.server_name}</td><td className="text-cyan-300">{p.slug}</td><td><Pill>{p.format}</Pill></td><td className="text-slate-500">{fmtTime(p.since)}</td><td className="text-slate-500">{p.idle}s</td></tr>
            ))}</tbody>
          </table>
        )}
      </Panel>
      <Tabs value={tab} onValueChange={setTab} className="mb-3">
        <TabsList className="bg-[#0F1722] border border-slate-800">
          <TabsTrigger value="all" data-testid="access-tab-all">All</TabsTrigger>
          <TabsTrigger value="allowed" data-testid="access-tab-allowed">Allowed</TabsTrigger>
          <TabsTrigger value="denied" data-testid="access-tab-denied">Denied</TabsTrigger>
        </TabsList>
      </Tabs>
      <div className="bg-[#0F1722] border border-slate-800 rounded-md overflow-hidden">
        <table className="w-full text-xs" data-testid="access-log-table">
          <thead><tr className="border-b border-slate-800 text-left text-[10px] uppercase tracking-wider text-slate-500">{["Time", "IP", "Matched server", "Channel", "Format", "Result"].map((h) => <th key={h} className="px-4 py-2 font-semibold">{h}</th>)}</tr></thead>
          <tbody>{(data || []).map((l) => (
            <tr key={l.id} className="border-b border-slate-800/60 font-mono">
              <td className="px-4 py-1.5 text-slate-500">{fmtTime(l.ts, true)}</td><td className="px-4 text-slate-200">{l.ip}</td>
              <td className="px-4 text-slate-300">{l.server_name || "—"}</td><td className="px-4 text-cyan-300">{l.slug}</td>
              <td className="px-4"><Pill>{l.format}</Pill></td>
              <td className="px-4"><Pill tone={l.allowed ? "green" : "red"}>{l.allowed ? "allowed" : `403 · ${l.reason}`}</Pill></td>
            </tr>
          ))}</tbody>
        </table>
        {data && data.length === 0 && <p className="text-sm text-slate-500 p-4">No requests logged.</p>}
      </div>
    </div>
  );
}
